import '../../Styles/inyournearSponsorshipExamplesSlider.scss';

await import('slick-carousel');
await import(/* webpackChunkName: "jquery-match-height" */ 'jquery-match-height');
 
await import(/* webpackChunkName: "ajax" */ 'Feature/Common/code/Scripts/Common/ajax');
await import(/* webpackChunkName: "sync" */ 'Feature/Common/code/Scripts/Common/sync');
 
await import(/* webpackChunkName: "helpers" */ 'Foundation/Common/code/Scripts/Common/helpers');
await import(/* webpackChunkName: "requiredAdvanced" */ 'Foundation/Forms/code/Scripts/requiredAdvanced');

await import(/* webpackChunkName: "forms" */ 'Feature/Forms/code/Scripts/forms');

window.am = window.am || {};

window.am.inyournearSponsorshipExamplesSlider = new function () {
    var that = this;

    that.trackClick = function (element) {
        var eventId = element.dataset.eventId;

        if (!eventId) {
            return;
        }

        if (utag != undefined) {
            utag.link({
                'etracker_event_action': 'click',
                'event_id': eventId
            });
        }
    }

    that.init = function () {

        let inyourAreaSponsorshipExamples = document.querySelectorAll('.inyourarea-sponsorshipexamples');

        if (inyourAreaSponsorshipExamples == null || inyourAreaSponsorshipExamples.length == 0) {
            return;
        }

        for (var exampleIndex = 0; exampleIndex < inyourAreaSponsorshipExamples.length; exampleIndex++) {
            let inyourAreaSponsorshipExample = inyourAreaSponsorshipExamples[exampleIndex];
            let wrapper = inyourAreaSponsorshipExample.querySelector('.inyourarea-sponsorshipexamples-slider-wrapper.ready');

            if (wrapper == null) {
                continue;
            }

            let slider = wrapper.querySelector('.slider');

            initSlider(slider, wrapper);

            let searchForm = inyourAreaSponsorshipExample.querySelector('.am-form form');

            if (searchForm) {
                searchForm.addEventListener('submit', function (event) {
                    /* prevent page reload */
                    event.preventDefault();

                    if (window.am.forms.shouldSubmit(searchForm)) {
                        refreshSlides(searchForm, inyourAreaSponsorshipExample, wrapper);
                        return true;
                    }

                    return false;
                });

                let changePostalCodeButton = inyourAreaSponsorshipExample.querySelector('.change-postalcode-button');

                if (changePostalCodeButton != null) {
                    changePostalCodeButton.addEventListener('click', function () {
                        let selectForm = inyourAreaSponsorshipExample.querySelector('.select-form');
                        let selectedForm = inyourAreaSponsorshipExample.querySelector('.selected-area');

                        selectForm.classList.remove('d-none');
                        selectedForm.classList.add('d-none');
                    });
                }
            }
        }

        function refreshSlides(form, inyourAreaSponsorshipExample, wrapper) {
            let host = window.location.protocol + '//' + window.location.hostname;
            var url = new URL('/api/sitecore/sponsorshipexamples/getinyournearsponsorshipexamplesliderteasers', host);

            url.searchParams.append('datasource', form.querySelector('[name="DatasourceId"]').value);
            url.searchParams.append('postalCode', form.querySelector('[name="PostalCode"]').value);

            window.am.ajax.sendRequest(
                url,
                'GET',
                function (response) { successCallback(response, form, inyourAreaSponsorshipExample, wrapper); },
                function () { window.am.forms.enableSubmitButton(form); })
        }

        function successCallback(response, form, area, wrapper) {

            let slider = wrapper.querySelector('.slider');
            $(slider).slick('unslick');
            $(slider).off();

            slider.innerHTML = response.html;

            initSlider(slider, wrapper);

            let selectForm = area.querySelector('.select-form');
            let selectedForm = area.querySelector('.selected-area');
            selectForm.classList.add('d-none');
            selectedForm.classList.remove('d-none');

            let postalcodeValue = form.querySelector('[name="PostalCode"]').value;
            let contentEl = selectedForm.querySelector('.simple-content');
            let dataTemplate = contentEl.getAttribute('data-content');

            if (dataTemplate) {
                dataTemplate = atob(dataTemplate).replace(/\$postalcode/g, postalcodeValue);
            }
            contentEl.innerHTML = dataTemplate;

            window.am.forms.enableSubmitButton(form);
        }

        function initSlider(slider, wrapper) {
            let $wrapper = $(wrapper);
            let $slider = $(slider);
            let $prevArrow = $wrapper.find(".pagination .pagination-prev");
            let $nextArrow = $wrapper.find(".pagination .pagination-next");
            let $dotsNavContainer = $wrapper.find(".pagination-dots");
            let isSliderWithLessSlides = slider.childElementCount <= 3;

            if (!isSliderWithLessSlides) {
                let $status = $wrapper.find(".pagingInfo");

                $status.addClass("show");

                if ($dotsNavContainer) {
                    $dotsNavContainer.addClass('d-none');
                }

                $slider.on("init reInit afterChange", function (event, slick, currentSlide, nextSlide) {

                    let totalCount = slick.getDotCount() + 1;

                    if (totalCount == 1) {

                        if (!$status.hasClass('d-none')) {
                            $status.addClass('d-none');
                        }
                        return;
                    }

                    let currentSlideNo = (currentSlide ? currentSlide : 0);

                    currentSlideNo = currentSlideNo / slick.options.slidesToScroll;

                    /* 0 index based */
                    currentSlideNo = currentSlideNo + 1;

                    $status.text(currentSlideNo + " / " + totalCount);

                    $status.removeClass('d-none');
                });
            }
            
            $slider.on("afterChange", function (slick, currentSlide, nextSlide) {
                if (utag != undefined && wrapper.dataset.trackingSliderChangeEventId) {
                    utag.link({
                        'etracker_event_action': 'click',
                        'event_id': wrapper.dataset.trackingSliderChangeEventId
                    });
                }
            });

            $slider.not('.slick-initialized').slick({
                speed: 0,
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: true,
                centerMode: false,
                dots: false,
                appendDots: $dotsNavContainer,
                infinite: true,
                variableWidth: true,
                responsive: [
                    {
                        breakpoint: 1025,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            centerMode: true,
                        }
                    }
                ],
                prevArrow: $prevArrow,
                nextArrow: $nextArrow,
                dotsClass: isSliderWithLessSlides ? "pagination-dots" : "d-none"
            });

            $slider.find('.slider-item .teaser-content .teaser-headline:not(.no-text)').matchHeight();
        }
    }
}

window.am.inyournearSponsorshipExamplesSlider.init()